<script setup lang="ts">
import { mdiClockOutline } from "@mdi/js";
import { betwayBetbookCashout, betwayBetbookStats, betwayBetbookStreaming } from "~/assets/betwayIcons";
import { useBetbook } from "~/store/betbook";
import { IEvent } from "~/types/sports/event";
import { IScore } from "~/types/sports/score";
import { formatStateText } from "~/utils/sport/formatScore";
import sportUrlBuilder from "~/utils/sport/sportUrlBuilder";
import LiveIndicator from "../LiveIndicator.vue";
import t from "~/utils/translate";

interface Props {
	event: IEvent | undefined;
	score: IScore | undefined;
}
const store = useBetbook();
const props = defineProps<Props>();
const route = useRoute();
const { fixtureType } = route.params;

const fullEvent = computed(() => props.event && store.getEvent(props.event.eventId));
</script>

<template>
	<div
		class="relative flex flex-row flex-1 col-span-11 md:mt-1 overflow-hidden md:pr-2 md:col-span-5 md:flex-col text-dark-300 dark:text-light-600 whitespace-nowrap leading-6 md:leading-[16px]"
	>
		<NuxtLink
			class="text-[currentColor] hover:text-[currentColor]"
			rel="ugc noindex nofollow"
			:href="
				sportUrlBuilder({
					fixtureType: fixtureType,
					sport: event?.sportId,
					event: {
						awayTeam: event?.awayTeam ?? '',
						homeTeam: event?.homeTeam ?? '',
						eventId: event?.eventId ?? 0,
						leagueId: event?.leagueId ?? '',
						regionId: event?.regionId ?? '',
						expectedEndEpoch: event?.expectedEndEpoch ?? 0,
						expectedStartEpoch: event?.expectedStartEpoch ?? 0,
					},
				})
			"
		>
			<div class="flex items-center" v-if="event?.isLive">
				<LiveIndicator /> <span v-if="score">{{ formatStateText(score) }}</span>
				<span v-if="score && score.time > 0 && score.timePeriod === 'Overs'" class="capitalize">&nbsp;|&nbsp;{{ t("over") }} {{ score.time }}</span>
				<span v-else-if="score && score?.time > 0">&nbsp;|&nbsp;{{ score.time >= 10 ? `${score.time}:00 min` : `0${score.time}:00 min` }} </span>
			</div>
			<div v-else class="flex items-center gap-1">
				<UiIcon :path="mdiClockOutline" class="w-4 h-4 fill-dark-300 dark:fill-light-600 flex-shrink-0" />
				<UiDateTime dateFormat="dd MMM -" timeFormat=" HH:mm" time :date="event?.expectedStartEpoch || ''" />
			</div>
			<div class="hidden overflow-hidden text-ellipsis md:block">
				<span class="inline-block md:hidden">&nbsp;|&nbsp;</span>{{ event?.league }}, {{ event?.region }}
			</div>
		</NuxtLink>
	</div>
</template>
